<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="400px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>بارگزاری فایل اکسل اشخاص</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form ref="form"  lazy-validation>
            <v-row>
              <v-col
                  cols="12"
                  sm="12"

              >
                <v-autocomplete
                    :items="buildingList"
                    v-model="buildingId"
                    label="انتخاب مجتمع"
                    dense
                    outlined
                    :error-messages="getError('buildingId')"
                    auto-select-first append-icon="mdi-menu-down"
                />

              </v-col>
              <v-col cols="12" sm="12">
                <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    v-model="file"
                    show-size
                    label="اکسل شامل اطلاعات کاربر"
                    :error-messages="getError('file')"
                ></v-file-input>
              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" p-1 m-1"
                  @click="upload"
              >
                <v-icon class="mx-1">mdi-cloud-upload</v-icon>بارگزاری
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import User_se from "./User_se";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    buildingList: Array,
  },
  data() {
    return {
      bindingErrors: [],
      file: [],
      buildingId:''

    }
  },


  methods: {

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.loading = false
      this.bindingErrors = []
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('User')
    },
    upload() {
      this.bindingErrors = []
      this.$progress({message: 'درحال ذخیره اطلاعات...'}, true)
      User_se.upload(this.file ,this.buildingId).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success', message: 'درحال ذخیره اطلاعات...'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.$snack({type: 'error', message: response.response.data})
          this.bindingErrors = response.response.data;
        }
      })
    },
  },


}
</script>


